import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { AuthShell, Field, inputCls, btnPrimary } from "@/components/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/studio"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : "/studio");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell eyebrow="01 — Accesso Studente" title={<>Bentornato.<br />Riprendi a studiare.</>}>
      <form onSubmit={submit} className="space-y-6" data-testid="login-form">
        <Field label="Email">
          <input data-testid="login-student-email-input" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="nome@scuola.it" />
        </Field>
        <Field label="Password">
          <input data-testid="login-student-password-input" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} required />
        </Field>
        <div className="flex flex-wrap items-center gap-6 pt-2">
          <button data-testid="login-student-submit-btn" disabled={loading} className={btnPrimary}>
            {loading ? "Accesso…" : "Accedi"} <ArrowRight className="w-4 h-4" />
          </button>
          <Link to="/register" data-testid="go-register-link" className="text-sm font-medium underline underline-offset-4 hover:text-[#0D9488]">
            Non hai un account? Registrati
          </Link>
        </div>
        <Link to="/admin/login" data-testid="go-admin-login-link" className="block pt-8 font-mono text-[10px] uppercase tracking-widest text-zinc-400 hover:text-zinc-950">
          → Area Super Admin
        </Link>
      </form>
    </AuthShell>
  );
}
